<h1 mat-dialog-title>ユーザーをCSVからインポート</h1>

<div mat-dialog-content>
  <form class="import-form" #importForm="ngForm">
    <input type="file" accept=".csv" id="hiddenFile" (change)="onChangeInput($event)">
    <span>

      <!-- <mat-form-field class="pathInput">
        <input matInput placeholder="CSVパス" id="filePath" [(ngModel)]="csvFullPath" name="filePath" #filePath="ngModel">
      </mat-form-field> -->
      <button type="selectFile" (click)="readFile()" mat-raised-button>参照</button>
      <!-- <button type=" readFile" (click)="readFile()" mat-raised-button>読込</button> -->
    </span>
    <span>
      <p>{{content}}</p>
    </span>
    <span>
      <button type="cancel" (click)="onCancel()" mat-raised-button>キャンセル</button>
      <button type="submit" (click)="onSubmit()" mat-raised-button [disabled]="submitting">登録</button>
    </span>
  </form>
</div>
